// packages
const { h, Component } = require("preact");

// components
import LookupBar from './LookupBar';

// internal

class LookupRow extends Component {
  constructor(props) {
    super();

    this.state = {
      filteredData2026: [],
      filteredData2024: [],
      filteredData2022: [],
      filteredData2020: [],
      filteredData2018: null
    };
    this.parseData(props.data, props.county);
  }

  parseData(data, county) {
    const filteredData2026 = data['2026-county-turnout'].filter(d => d.County == county)[0];
    const filteredData2024 = data['2024-county-turnout'].filter(d => d.County == county)[0];
    const filteredData2022 = data['2022-county-turnout'].filter(d => d.County == county)[0];
    const filteredData2020 = data['2020-county-turnout'].filter(d => d.County == county)[0];
    const filteredData2018 = data['2018-county-turnout'].filter(d => d.County == county)[0] || null;
    this.setState({
      filteredData2026: filteredData2026,
      filteredData2024: filteredData2024,
      filteredData2022: filteredData2022,
      filteredData2020: filteredData2020,
      filteredData2018: filteredData2018
    })
  }

  componentDidUpdate(prevProps) {
    if(prevProps.county != this.props.county) {
      this.parseData(this.props.data, this.props.county)
    }
  }

  render() {
    const { filteredData2026, filteredData2024, filteredData2022, filteredData2020, filteredData2018 } = this.state;

    if (!filteredData2026 || !filteredData2024 || !filteredData2022 || !filteredData2020) {
      return <div class="county-bars">Loading...</div>;
    }

    return (
      <div class="county-bars">
        <div class="bar-row statewide-2026">
          <div class="bar-cell year">2026</div> 
          <div class="bar-cell bar">
            <LookupBar
              regVoters2024={filteredData2026.registered}
              regVoters={filteredData2026.registered}
              ev={filteredData2026.early_vote}
              pct_ev={filteredData2026.early_vote_pct}
              voted={filteredData2026.eday_vote || 0}
              pct_voted={filteredData2026.eday_vote_pct || 0}
              year={2026}
            />
          </div>
        </div>
        <div class="bar-row statewide-2024">
          <div class="bar-cell year">2024</div> 
          <div class="bar-cell bar">
            <LookupBar
              regVoters2024={this.state.filteredData2026.registered}
              regVoters={this.state.filteredData2024.registered}
              ev={this.state.filteredData2024.early_vote}
              pct_ev={this.state.filteredData2024.early_vote_pct}
              voted={this.state.filteredData2024.eday_vote}
              pct_voted={this.state.filteredData2024.eday_vote_pct}
              year={2024}
            />
          </div>
        </div>
        <div class="bar-row statewide-2022">
          <div class="bar-cell year">2022</div> 
          <div class="bar-cell bar">
            <LookupBar
              regVoters2024={this.state.filteredData2026.registered}
              regVoters={this.state.filteredData2022.registered}
              ev={this.state.filteredData2022.early_vote}
              pct_ev={this.state.filteredData2022.early_vote_pct}
              voted={this.state.filteredData2022.eday_vote}
              pct_voted={this.state.filteredData2022.eday_vote_pct}
              year={2022}
            />
          </div>
        </div>
        <div class="bar-row statewide-2020">
          <div class="bar-cell year">2020</div>
          <div class="bar-cell bar">
            <LookupBar
              regVoters2024={this.state.filteredData2026.registered}
              regVoters={this.state.filteredData2020.registered}
              ev={this.state.filteredData2020.early_vote}
              pct_ev={this.state.filteredData2020.early_vote_pct}
              voted={this.state.filteredData2020.eday_vote}
              pct_voted={this.state.filteredData2020.eday_vote_pct}
              year={2020}
            />
          </div>
        </div>
        {filteredData2018 && (
          <div class="bar-row statewide-2018">
            <div class="bar-cell year">2018*</div>
            <div class="bar-cell bar">
              <LookupBar
                regVoters2024={this.state.filteredData2026.registered}
                regVoters={filteredData2018.registered}
                ev={filteredData2018.early_vote}
                pct_ev={filteredData2018.early_vote_pct}
                voted={0}
                pct_voted={0}
                year={2018}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default LookupRow;